<template>
    <div>
        <div id="navigationPlaceholder" style="padding-top: 80px;">
            <AdminNavigationV2 :tid="tid"></AdminNavigationV2>
        </div>

        <div class="container">
            <div class="row">
                <div class="col-lg-7">
                    <h1 style="font-size: 2em; font-weight: 300; color: #33475b;">Active shares</h1>
                </div>
                <div class="col-lg-5 col-sm-6 text-right">
                </div>
            </div>
        </div>

        <hr style="border-color: #bbb; margin: 20px 0 30px;" />

        <div class="container">
            <table class="table table-striped">
                <thead>
                    <tr>
                        <th scope="col">#</th>
                        <th scope="col">Workspace</th>
                        <th scope="col">Portfolio</th>
                        <th scope="col">Data</th>
                        <th scope="col">Shared&nbsp;by</th>
                        <th scope="col">Shared&nbsp;with</th>
                        <th scope="col">Shared&nbsp;at</th>
                        <th scope="col">Shared&nbsp;for</th>
                    </tr>
                </thead>
                <tbody>
                    <tr v-for="(s, i) in shares" :key="s.Id">
                        <th scope="row">{{i+1}}</th>
                        <td>{{s.WorkspaceName}}</td>
                        <td>{{s.PortfolioName}}</td>
                        <td>
                            <a :href="s.ResourceUrl" target="_blank">{{s.ResourceName}}</a>
                        </td>
                        <td>{{s.SharedBy}}</td>
                        <td>{{s.SharedWith}}</td>
                        <td>{{s.SharedAt}}</td>
                        <td>{{s.SharedFor}}</td>
                    </tr>
                </tbody>
            </table>
        </div>
    </div>
</template>

<script lang="ts" setup>
    import { ref, computed, watch, onMounted } from 'vue'
    import { useRoute } from '@common/composables'
    import { useAdminActiveSharesPage } from '@DataSharing/Shares/pages-core'

    document.title = 'Shares'

    const tid = useRoute().params.tid

    const { useActiveSharesQuery } = useAdminActiveSharesPage()

    const { modelActiveSharesQueryV1, runActiveSharesQueryV1 } = useActiveSharesQuery(parseInt(tid))

    const shares = computed(() => modelActiveSharesQueryV1.value?.Shares || [])

    onMounted(() => runActiveSharesQueryV1())
</script>
